import { selectResponseData } from 'util/selector/axiosSelector';

import { AxiosInstance } from 'axios';

import {
  DigestActionType,
  LinkResetDigestPreferenceDto,
  LinkResetDigestSurveyDto,
  LinkResetDigestSurveyModel,
} from './dto/LinkResetDigest.dto';

export type FetchLinkResetDigestParams = {
  /**
   * YYYY-MM-DD. Omitted means yesterday in UTC, which is what admin-service falls back to.
   */
  date?: string;
  action?: DigestActionType;
};

export class LinkResetDigestApi {
  constructor(private client: AxiosInstance) {}

  fetchDigest({ date, action }: FetchLinkResetDigestParams = {}): Promise<
    LinkResetDigestSurveyModel[]
  > {
    return this.client
      .get<{ data: LinkResetDigestSurveyDto[] }>('/api/v1/link-reset/admin/digest', {
        params: { date, action },
      })
      .then((response) => {
        const responseData = selectResponseData(response);
        return responseData.data;
      });
  }

  fetchNotificationPreference(): Promise<boolean> {
    return this.client
      .get<{
        data: LinkResetDigestPreferenceDto;
      }>('/api/v1/link-reset/admin/digest/notification-preference')
      .then((response) => {
        const responseData = selectResponseData(response);
        return responseData.data.enabled;
      });
  }

  updateNotificationPreference(enabled: boolean): Promise<boolean> {
    return this.client
      .put<{
        data: LinkResetDigestPreferenceDto;
      }>('/api/v1/link-reset/admin/digest/notification-preference', { enabled })
      .then((response) => {
        const responseData = selectResponseData(response);
        return responseData.data.enabled;
      });
  }
}
